var _g, _rect, _rect2, _path, _rect3, _rect4, _path2, _path3, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path4, _path5, _rect12, _rect13, _rect14, _path6, _path7, _rect15, _rect16, _rect17, _path8, _path9, _rect18, _rect19, _rect20, _path10, _path11, _rect21, _rect22, _rect23, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 491,
    height: 315,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.205 157.29C344.421 70.863 274.534.624 188.107.408 101.681.19 31.442 70.078 31.226 156.506c-.217 86.426 69.67 156.665 156.097 156.881 86.427.217 156.665-69.671 156.882-156.097Z",
    fill: "#CDEBFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.068 25.25c.028-11.106-8.953-20.132-20.059-20.16-11.106-.028-20.132 8.953-20.16 20.06-.028 11.106 8.953 20.132 20.059 20.16 11.107.027 20.133-8.954 20.16-20.06ZM24.532 230.501l33.423-33.256 33.256 33.423-33.423 33.255-33.256-33.422Z",
    fill: "#072D83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.59 263.942 16.37-16.289 16.288 16.37-16.37 16.289-16.288-16.37Z",
    fill: "#FF9B21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.52 38.798 8.186-8.144 8.144 8.185-8.185 8.144-8.145-8.185Z",
    fill: "#2026A2"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 216.205,
    y: 60.542,
    width: 188.608,
    height: 180.07,
    rx: 8,
    fill: "#F2F2F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 352.81,
    y: 87.707,
    width: 41.913,
    height: 48.122,
    rx: 8,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.646 115.53c5.274 0 9.55-4.329 9.55-9.669 0-5.339-4.276-9.668-9.55-9.668-5.273 0-9.549 4.329-9.549 9.668 0 5.34 4.276 9.669 9.549 9.669Z",
    fill: "#ECEFF1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 358.726,
    y: 117.947,
    width: 29.841,
    height: 3.626,
    rx: 1.813,
    fill: "#ECEFF1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 363.5,
    y: 123.989,
    width: 20.292,
    height: 3.626,
    rx: 1.813,
    fill: "#ECEFF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.205 68.542a8 8 0 0 1 8-8h172.608a8 8 0 0 1 8 8v8.3H216.205v-8.3Z",
    fill: "#B0BEC5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.963 71.419c1.319 0 2.388-1.083 2.388-2.418 0-1.334-1.069-2.416-2.388-2.416-1.318 0-2.387 1.082-2.387 2.416 0 1.335 1.069 2.418 2.387 2.418ZM231.125 71.419c1.319 0 2.387-1.083 2.387-2.418 0-1.334-1.068-2.416-2.387-2.416-1.318 0-2.387 1.082-2.387 2.416 0 1.335 1.069 2.418 2.387 2.418ZM238.287 71.419c1.318 0 2.387-1.083 2.387-2.418 0-1.334-1.069-2.416-2.387-2.416-1.319 0-2.387 1.082-2.387 2.416 0 1.335 1.068 2.418 2.387 2.418Z",
    fill: "#F2F2F2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 352.81,
    y: 139.71,
    width: 41.913,
    height: 89.259,
    rx: 8,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 363.587,
    y: 154.788,
    width: 20.358,
    height: 15.681,
    rx: 4,
    fill: "#ECEFF1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 363.587,
    y: 175.293,
    width: 20.358,
    height: 15.078,
    rx: 4,
    fill: "#B0BEC5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 363.587,
    y: 195.196,
    width: 20.358,
    height: 15.078,
    rx: 4,
    fill: "#ECEFF1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 225.519,
    y: 87.707,
    width: 117.201,
    height: 27.942,
    rx: 4,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 232.504,
    y: 96.031,
    width: 62.093,
    height: 4.236,
    rx: 2.118,
    fill: "#ECEFF1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 232.504,
    y: 103.09,
    width: 41.679,
    height: 4.236,
    rx: 2.118,
    fill: "#ECEFF1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.818 104.395a5.433 5.433 0 1 0 0-10.866 5.433 5.433 0 0 0 0 10.866Z",
    fill: "#ECEFF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.818 101.29a2.328 2.328 0 1 0 0-4.655 2.328 2.328 0 0 0 0 4.655Z",
    fill: "#F9FAFB"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 225.519,
    y: 120.306,
    width: 117.201,
    height: 24.061,
    rx: 4,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 232.504,
    y: 127.71,
    width: 62.093,
    height: 3.47,
    rx: 1.735,
    fill: "#ECEFF1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 232.504,
    y: 133.494,
    width: 41.679,
    height: 3.47,
    rx: 1.735,
    fill: "#ECEFF1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.818 135.441a5.433 5.433 0 1 0 0-10.866 5.433 5.433 0 0 0 0 10.866Z",
    fill: "#ECEFF1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.818 132.337a2.328 2.328 0 1 0-.001-4.657 2.328 2.328 0 0 0 .001 4.657Z",
    fill: "#F9FAFB"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 225.519,
    y: 149.024,
    width: 117.201,
    height: 23.285,
    rx: 4,
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 232.504,
    y: 156.189,
    width: 62.869,
    height: 3.358,
    rx: 1.679,
    fill: "#ECEFF1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 232.504,
    y: 161.786,
    width: 42.2,
    height: 3.358,
    rx: 1.679,
    fill: "#ECEFF1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.818 163.384a5.434 5.434 0 1 0-.002-10.868 5.434 5.434 0 0 0 .002 10.868Z",
    fill: "#ECEFF1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.818 160.279a2.328 2.328 0 1 0-.001-4.657 2.328 2.328 0 0 0 .001 4.657Z",
    fill: "#B0BEC5"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 225.519,
    y: 205.685,
    width: 117.201,
    height: 23.285,
    rx: 4,
    fill: "#fff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 232.504,
    y: 212.849,
    width: 63.645,
    height: 3.358,
    rx: 1.679,
    fill: "#ECEFF1"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 232.504,
    y: 218.446,
    width: 42.721,
    height: 3.358,
    rx: 1.679,
    fill: "#ECEFF1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.818 220.044a5.434 5.434 0 1 0-.002-10.868 5.434 5.434 0 0 0 .002 10.868Z",
    fill: "#ECEFF1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.818 216.939a2.328 2.328 0 1 0-.001-4.657 2.328 2.328 0 0 0 .001 4.657Z",
    fill: "#F9FAFB"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 225.519,
    y: 177.743,
    width: 117.201,
    height: 23.285,
    rx: 4,
    fill: "#fff"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 232.504,
    y: 184.907,
    width: 62.869,
    height: 3.358,
    rx: 1.679,
    fill: "#ECEFF1"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 232.504,
    y: 190.504,
    width: 42.2,
    height: 3.358,
    rx: 1.679,
    fill: "#ECEFF1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.818 192.102a5.434 5.434 0 1 0-.001-10.867 5.434 5.434 0 0 0 .001 10.867Z",
    fill: "#ECEFF1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.818 188.997a2.328 2.328 0 1 0 0-4.655 2.328 2.328 0 0 0 0 4.655Z",
    fill: "#F9FAFB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.52 146.598c3.344 1.42 6.5 1.889 7.87 1.324 3.438-1.418 1.937-14.47-1.542-19.21-3.48-4.74-17.979-4.981-17.266 5.279.247 3.56 2.175 6.498 4.73 8.758l-1.365 18.834 11.427-1.606-3.854-13.379Z",
    fill: "#B28B67"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.549 123.762c-1.628-.256-3.918-.098-4.856.145a8.263 8.263 0 0 0 0-4.227c-.363-1.342-1.138-2.419-1.876-3.558-.339-.525-.714-1.042-1.215-1.409a3.442 3.442 0 0 0-1.735-.638 4.38 4.38 0 0 0-1.86.26c-.262.095-.487.252-.743.358-.261.108-.417-.043-.638-.185-.532-.344-1.257-.449-1.868-.437-.686.014-1.371.214-1.983.525-.595.303-1.147.737-1.528 1.309-.17.255-.316.538-.395.839-.032.124-.031.194-.142.254-.102.054-.228.073-.335.127-1.027.516-1.833 1.476-2.185 2.614-.206.664-.191 1.779.02 3.002.211 1.224 1.774 4.273 2.979 5.296 1.075.913 2.538 1.41 3.898 1.526-.735 1.12-1.142 2.447-1.395 3.774a17.302 17.302 0 0 0-.264 4.384c.093 1.398.289 2.863.805 4.172.482 1.223 1.279 2.171 2.459 2.677.54.232 1.107.384 1.675.516.56.129 1.12.253 1.693.29 1.083.069 2.29-.139 2.984-1.088.25-.343.518-.766.679-1.164.059-.143.093-.236-.019-.352-.133-.139-.33-.233-.491-.334a4.13 4.13 0 0 1-1.831-2.505c-.286-1.094-.188-2.571.828-3.209 1.255-.787 2.825-.306 4.105.168.256-1.851 1.069-3.599 2.582-4.643 1.673-1.156 3.725-1.552 5.467-2.587.453-.27.912-.568 1.21-1.029.124-.193.266-.44.294-.676.036-.31-.193-.533-.375-.745-.965-1.123-4.316-3.195-5.944-3.45Z",
    fill: "#191847"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m229.038 199.338 35.729 59.552 26.786 50.347h5.77l-44.881-109.899h-23.404Z",
    fill: "#997659"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.402 306.798c-1.098-.4-2.376.061-2.727 1.176-.245.778-.456 1.607-.456 2.152 0 1.297.433 3.785.433 3.785h27.12s1.057-3.484-1.221-3.762a162.174 162.174 0 0 1-3.784-.502l-12.119-5.386a1 1 0 0 0-1.33.531l-.606 1.467s-2.109.981-3.427.981c-.515 0-1.217-.199-1.883-.442Z",
    fill: "#E4E4E4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m284.114 301.175 11.126-3.356s-7.312-21.794-17.924-47.966c-10.612-26.173-22.794-50.515-22.794-50.515h-31.425s13.544 30.791 28.716 55.956c15.173 25.165 32.301 45.881 32.301 45.881Z",
    fill: "#FFCA28"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.69 199.338c-3.372 20.927-9.876 47.664-10.49 48.489-.409.55-15.14 5.471-44.193 14.764l1.246 5.072c34.646-4.983 52.901-8.85 54.766-11.599 2.798-4.125 16.766-36.706 22.176-56.726H226.69Z",
    fill: "#B28B67"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m182.22 258.206 2.195 8.17c25.913 2.266 41.79.628 47.632-4.912 5.842-5.54 12.5-26.249 19.974-62.126h-29.965c-4.736 29.378-7.383 44.684-7.943 45.917-.559 1.234-11.19 5.551-31.893 12.951Z",
    fill: "#F2C94C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.953 262.805c.205-1.154-.474-2.336-1.637-2.488-.809-.105-1.663-.168-2.201-.073-1.28.225-3.662 1.082-3.662 1.082l4.709 26.628s3.625.433 3.504-1.852a162.581 162.581 0 0 1-.162-3.802l3.215-12.828a1.001 1.001 0 0 0-.757-1.221l-1.552-.34s-1.335-1.9-1.564-3.194c-.088-.502-.015-1.22.107-1.912Z",
    fill: "#E4E4E4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m262.841 157.075-15.259 11.348 7.021 5.673 10.468-12.65c6.082-2.628 8.797-4.306 8.143-5.035-.55-.615-1.282-.488-1.955-.371-.525.091-1.014.176-1.356-.101-.782-.631.157-3.354 1.158-5.9 1.002-2.546-.395-2.14-1.162-1.687-2.414 2.175-4.767 5.083-7.058 8.723Zm18.396 10.328-6.7 4.996 1.434 7.205s4.226-4.044 8.113-5.737c4.956-2.159 6.889-3.547 8.96-7.103 1.108-1.902 1.768-5.507.327-6.448-.553-.361-2.245.913-3.971 2.213-1.315.991-2.651 1.997-3.517 2.306-1.167.415-1.244-1.157-1.306-2.413-.045-.902-.081-1.64-.506-1.366-2.12.335-2.834 6.347-2.834 6.347Z",
    fill: "#997659"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.251 167.543c5.78-.874 13.328-3.178 20.832-9.548l4.246 6.737c-4.892 6.42-12.231 12.161-19.244 12.948-5.526.619-9.273-5.624-5.834-10.137Z",
    fill: "#2026A2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.563 219.01c-5.604.058-10.753.112-13.667 1.121-4.893-10.414-3.064-17.661-1.376-24.351 1.018-4.032 1.984-7.862 1.397-12.061-1.709-12.227 5.493-32.43 6.941-32.633l13.212-1.857c1.654 7.483 5.326 15.32 9.022 23.208.863 1.842 1.727 3.686 2.568 5.53 9.907.824 30.164-9.737 30.164-9.737s6.942 10.345 7.2 15.13c-11.501 8.207-21.732 12.583-30.468 14.005 1.007 5.144 1.067 10.166-.425 14.972-2 6.439-14.08 6.564-24.568 6.673Z",
    fill: "#072D83"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.673 146.47c-2.862 2.237-5.788 3.507-7.259 3.316-3.687-.48-5.616-13.476-3.482-18.955 2.135-5.479 16.077-9.464 18.044.63.683 3.504-.418 6.84-2.302 9.684l6.193 17.839-11.454 1.406.26-13.92Z",
    fill: "#B28B67"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.734 124.106c1.479-.432 5.523-1.101 6.272-1.192.479-.059 1.012-.014 1.242-.487.188-.388.028-.985.046-1.41.022-.494.077-.986.134-1.477a14.719 14.719 0 0 1 1.05-4.045c1.028-2.433 2.724-4.449 5.013-5.781 2.529-1.472 5.517-2.105 8.416-2.225 3.103-.129 6.008.54 9.026 1.136 2.875.567 5.814.568 8.651-.229 2.858-.804 4.865-2.648 7.139-4.444 2.327-1.838 5.079-3.191 8.08-3.326 2.802-.126 5.501.702 7.983 1.947 2.323 1.164 4.306 2.665 5.603 4.96 1.395 2.469 1.745 5.324.258 7.84-2.156 3.648-6.812 5.094-10.784 5.495-2.298.232-4.6.091-6.856-.402-3.01-.657-5.714-2.066-8.584-3.126a21.189 21.189 0 0 0-4.142-1.091c-1.377-.211-2.71-.222-3.818.728-1.171 1.005-2.212 1.979-3.606 2.69-1.337.681-2.785 1.148-4.278 1.32-2.905.334-5.876-.216-8.769-.474-2.359-.21-4.878-.399-7.163.362-.954.317-2.332.901-2.561 1.957 6.076.344 9.31 7.386 8.295 12.972-.547 3.015-5.567 7.077-7.868 5.81-1.458-.803-.801-2.172-.378-3.075.811-1.729.902-3.833-1.099-4.722-1.727-.766-3.137 1.73-3.169 1.732-.446.019-4.53-1.665-7.547-4.484-2.577.472-3.18-1.186-2.732-2.658.449-1.472 4.102-3.703 6.146-4.301Z",
    fill: "#191847"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.402 199.338c-.867 11.797-56.72 46.531-57.046 47.505-.217.65 17.385 41.074 17.385 41.074l-4.882 1.892s-26.999-42.813-25.612-47.374c1.985-6.532 43.335-42.972 43.335-42.972l26.82-.125Z",
    fill: "#B28B67"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m357.456 281.831-7.971 2.893c-16.809-18.908-23.397-34.509-22.196-42.458 1.201-7.949 43.186-42.899 43.186-42.899h28.498c-.972 27.321-52.741 47.58-53.433 48.744-.692 1.164 6.122 12.567 11.916 33.72Z",
    fill: "#072D83"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.264 287.692c.895-.751 2.255-.753 2.967.175.497.646.98 1.353 1.167 1.866.445 1.218.891 3.704.891 3.704l-25.484 9.247s-2.189-2.913-.144-3.951c2.045-1.038 3.384-1.762 3.384-1.762l9.54-9.193a1.001 1.001 0 0 1 1.433.046l1.073 1.171s2.317.203 3.556-.247c.483-.175 1.075-.601 1.617-1.056Z",
    fill: "#E4E4E4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m391.98 199.338 24.881 59.552 24.454 50.347h-5.77l-63.122-109.899h19.557Z",
    fill: "#997659"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.284 306.798c1.098-.4 2.375.061 2.727 1.176.245.778.456 1.607.456 2.152 0 1.297-.433 3.785-.433 3.785h-27.12s-1.057-3.484 1.22-3.762c2.278-.278 3.784-.502 3.784-.502l12.119-5.386a1 1 0 0 1 1.33.531l.607 1.467s2.108.981 3.427.981c.514 0 1.217-.199 1.883-.442Z",
    fill: "#E4E4E4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m439.107 298.778-12.82 2.397c-9.913-14.53-51.396-74.104-55.944-101.837h28.54c15.189 20.048 30.775 84.67 40.224 99.44Z",
    fill: "#072D83"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m329.806 184.921 18.222 5.449-4.656 7.73-14.166-8.31c-6.615-.39-9.74-1.039-9.375-1.948.307-.765 1.037-.896 1.71-1.017.524-.093 1.013-.181 1.24-.558.518-.86-1.296-3.098-3.108-5.148-1.813-2.05-.362-2.147.515-1.982 3.013 1.218 6.219 3.147 9.618 5.784Zm78.849 2.085 9.542-3.135c8.772 16.614 13.899 25.679 15.38 27.196 1.086 1.112 7.244 3.563 11.356 4.771 1.651.485 1.477 1.847 1.069 2.326-2.573 3.021-5.384 2.418-8.443 1.761-.886-.19-1.792-.384-2.72-.497-2.401-.291-2.964.991-3.495 2.203-.471 1.072-.917 2.09-2.594 1.911.035-.328.082-.696.133-1.094.329-2.572.815-6.364-.838-8.33-.848-1.008-7.312-10.046-19.39-27.112Z",
    fill: "#B28B67"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m377.358 151.856-4.214-.199c-7.921 9.797-9.024 31.132-14.675 34.632-5.343 3.309-13.682 1.766-23.644-.478l-2.123 6.869c9.819 8.288 29.261 13.921 36.195 8.491 11.085-8.681 10.686-34.779 8.461-49.315Z",
    fill: "#FFCA28"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m401.696 201.352-36.514 4.484c-1.669.205-1.649-2.236-1.557-3.478 1.066-14.33 10.081-30.744 7.636-50.657l10.33-2.94c10.427 12.899 15.552 29.728 20.105 52.591Z",
    fill: "#DDE3E9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m382.151 148.692.12-.015c25.406 11.614 42.446 32.36 51.119 62.239l-7.47 2.434c-5.793-5.266-13.233-14.136-22.321-26.608 3.274 7.783 5.957 15.849 7.437 23.606l-32.869 4.036c-8.331-15.251-.067-65.195-.067-65.195l2.27-.278 1.781-.219Z",
    fill: "#FFCA28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.03d5011094b3ba0458e408e54f84d86c.svg";
export { ForwardRef as ReactComponent };